import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

import Input from '../../../components/BaseUI/Input'
import Button from '../../../components/BaseUI/Button'
import Content from '../Content'

import styles from './ResendVerification.module.scss'
import { useTitle } from '../../../hooks/useTitle'
import { Toast, ToastContainer } from '../../../components/CustomUI/Toast'

const API_URL =
  process.env.REACT_APP_API_URL || 'https://dm.aibuddyassistant.com/api'

export default function ResendVerification() {
  const navigate = useNavigate()

  useTitle('Подтверждение Email | AIBuddy CRM')

  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [toast, setToast] = useState(null)
  const [sent, setSent] = useState(false)

  const handleSubmit = async () => {
    if (!email.trim()) {
      setToast({
        id: 1,
        title: 'Ошибка',
        description: 'Введите email',
        appearance: 'danger',
      })
      return
    }

    setLoading(true)
    setToast(null)

    try {
      await axios.post(`${API_URL}/auth/resend-verification`, {
        email: email.trim().toLowerCase(),
      })

      setSent(true)
      setToast({
        id: 1,
        title: 'Письмо отправлено',
        description:
          'Если аккаунт существует, ссылка для подтверждения отправлена на указанный email.',
        appearance: 'success',
      })
    } catch (error) {
      console.error('Resend verification error:', error)
      setToast({
        id: 1,
        title: 'Ошибка',
        description: 'Не удалось отправить письмо. Попробуйте позже.',
        appearance: 'danger',
      })
    } finally {
      setLoading(false)
    }
  }

  const removeToast = () => {
    setToast(null)
  }

  return (
    <div className={styles['resend-container']}>
      <Content
        title={sent ? 'Письмо отправлено' : 'Повторная отправка подтверждения'}
      >
        {sent ? (
          <div className={styles.content}>
            <div className={styles.iconSuccess}>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M22 2L11 13M22 2L15 22L11 13L2 9L22 2Z"></path>
              </svg>
            </div>
            <p className={styles.message}>
              Если аккаунт с указанным email существует и требует подтверждения,
              ссылка для активации была отправлена на {email}.
            </p>
            <p className={styles.hint}>
              Проверьте папку "Спам", если письмо не появится в течение
              нескольких минут.
            </p>
            <div className={styles.actions}>
              <Button
                title="Войти в систему"
                appearance="primary"
                isBlock={true}
                onClick={() => navigate('/login')}
              />
              <div className={styles.divider}></div>
              <Button
                title="Отправить снова"
                appearance="secondary"
                isBlock={true}
                onClick={() => setSent(false)}
              />
            </div>
          </div>
        ) : (
          <>
            <p className={styles.description}>
              Введите email, указанный при регистрации. Мы отправим вам новую
              ссылку для подтверждения.
            </p>
            <div className="mt-4">
              <Input
                type="email"
                label="Email"
                placeholder="Введите ваш email"
                className={styles['custom__input']}
                value={email}
                onChange={value => setEmail(value)}
              />
            </div>

            <div className="mt-2">
              <Button
                title={loading ? 'Отправка...' : 'Отправить ссылку'}
                appearance="primary"
                isBlock={true}
                onClick={handleSubmit}
                disabled={loading}
              />
            </div>

            <div className={styles['register']}>
              <span
                className={styles['link']}
                onClick={() => navigate('/login')}
              >
                Вернуться на страницу входа
              </span>
            </div>
          </>
        )}
      </Content>

      {toast && (
        <ToastContainer onDismissed={removeToast}>
          <Toast {...toast} isExpanded />
        </ToastContainer>
      )}
    </div>
  )
}
